import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, SectionLabel } from "./Reveal";

const STEPS = [
  { t: "Walk the property", d: "We visit your lot, learn the problem spots and agree on the rules you want enforced." },
  { t: "Post the signage", d: "Proper tow-away signage goes up at entrances so every driver is clearly warned." },
  { t: "Patrol & enforce", d: "Our drivers patrol on your schedule and remove vehicles that break your posted rules." },
  { t: "Stay in the loop", d: "Our property manager app shows you every removal — plate, time, location and reason." },
];

export const PropertyOwners = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="owners" ref={ref} data-testid="owners-section" className="border-t border-[var(--line)] bg-[var(--ink-2)]">
      <div className="mx-auto grid max-w-[1400px] gap-14 px-5 py-24 sm:px-8 lg:grid-cols-12 lg:py-36">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <Reveal>
              <SectionLabel index="02">For property owners</SectionLabel>
              <h2 className="font-display text-5xl font-black uppercase leading-[0.9] sm:text-6xl">Four steps to<br /><span className="text-[var(--signal)]">a clean lot.</span></h2>
            </Reveal>
            <Reveal delay={0.1} className="mt-10">
              <div className="clip-notch-sm relative aspect-[4/5] max-h-[520px] w-full overflow-hidden">
                <motion.img style={{ y }} src="/img/apartment-lot.jpg" alt="Apartment community parking lot with tow-away signage" className="absolute inset-0 h-[116%] w-full -translate-y-[8%] object-cover" />
              </div>
            </Reveal>
          </div>
        </div>
        <ol className="lg:col-span-6 lg:col-start-7">
          {STEPS.map((s, i) => (
            <Reveal key={s.t} delay={i * 0.05}>
              <li data-testid={`owner-step-${i + 1}`} className="group grid grid-cols-[auto_1fr] gap-6 border-b border-[var(--line)] py-10 sm:gap-10 sm:py-14">
                <span className="font-display text-6xl font-black leading-none text-outline transition-colors duration-500 group-hover:text-[var(--signal)] sm:text-8xl">{i + 1}</span>
                <div className="pt-2">
                  <h3 className="font-display text-3xl font-extrabold uppercase leading-none sm:text-4xl">{s.t}</h3>
                  <p className="mt-4 max-w-md text-base leading-relaxed text-zinc-300">{s.d}</p>
                </div>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
};
